import { navChips, siteStats } from '@/mocks/gossip';

export default function Masthead() {
  return (
    <header className="border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex items-center justify-between pt-5">
          <p className="font-label text-[10px] uppercase tracking-[0.4em] text-foreground-400">Daily Melon Report</p>
          <p className="text-[11px] text-foreground-500">第 {siteStats.issue} 期 · {siteStats.dateText}</p>
        </div>

        <div className="flex flex-col gap-5 pt-4 pb-6 md:flex-row md:items-end md:justify-between">
          <div>
            <h1 className="font-heading text-[2.75rem] font-black leading-none tracking-tight text-foreground-950 md:text-7xl">
              91<span className="text-primary-600">吃瓜</span>
            </h1>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              今天有哪些热门大瓜？网红黑料、明星八卦，一次看够。
            </p>
          </div>
          <div className="flex items-stretch gap-3">
            <div className="rounded-lg border border-background-200 bg-background-100 px-4 py-3 text-center">
              <p className="font-heading text-xl font-bold text-primary-700 md:text-2xl">
                {siteStats.onlineViewers.toLocaleString('en-US')}
              </p>
              <p className="mt-0.5 text-[11px] text-foreground-500">正在围观</p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-100 px-4 py-3 text-center">
              <p className="font-heading text-xl font-bold text-accent-700 md:text-2xl">
                {siteStats.totalMelons.toLocaleString('en-US')}
              </p>
              <p className="mt-0.5 text-[11px] text-foreground-500">累计爆料</p>
            </div>
          </div>
        </div>

        <nav className="mb-5 flex flex-wrap items-center gap-2 rounded-lg border border-background-200 bg-background-100 p-2.5">
          <span className="flex items-center gap-1.5 px-2 text-[11px] font-medium text-foreground-500">
            <i className="ri-compass-3-line text-sm text-primary-600" aria-hidden="true"></i>
            快速入口
          </span>
          {navChips.map((chip) => (
            <a
              key={chip.id}
              href={`#${chip.id}`}
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-300/70 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
            >
              {chip.label}
            </a>
          ))}
          <a
            href="#talk"
            className="ml-auto hidden cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-3.5 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600 sm:flex"
          >
            <i className="ri-chat-3-line text-sm" aria-hidden="true"></i>
            去聊两句
          </a>
        </nav>
      </div>
    </header>
  );
}